import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Row} from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import './AdminPages.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const PermissionAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [permissionAttrs, setPermissionAttrs] = useState({
    id: '',
    nameCode: '',
    description: '',
    creatorUsername: '',
    timeCreated: '',
    updaterUsername: '',
    timeUpdated: ''
  });

  const [currentPermissionAttrs, setCurrentPermissionAttrs] = useState({});

  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setPermissionAttrs(props.objDetails);
      setCurrentPermissionAttrs(props.objDetails);
    }
  }, [props]);

  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setPermissionAttrs({ ...permissionAttrs, [e.target.name]: e.target.value })
  }


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setPermissionAttrs(currentPermissionAttrs);

    setEditMode(false);
    setErrMsg('');
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    const reqBody = permissionAttrs;

    // Validation
    if (permissionAttrs.description.length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.put("permissions/" + permissionAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          //setCurrentPermissionAttrs(permissionAttrs);
          refreshPermissionAttrs(permissionAttrs.id);

          // Restore UI to viewing mode
          setEditMode(false);
          setErrMsg('');
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });

  }


  const refreshPermissionAttrs = (permissionId) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("permissions/" + permissionId);

        resolve(res.data);

        if (res.status === 200) {

          setPermissionAttrs(res.data[0]);
          setCurrentPermissionAttrs(res.data[0]);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Perm_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Perm_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col>{t("I18N_Perm_code")}:</Col>
                  <Col>{t("I18N_Description")}:</Col>
                  <Col></Col>
                  <Col></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col>{permissionAttrs.nameCode}</Col>
                  <Col>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={permissionAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col></Col>
                  <Col></Col>
                </Row>

{/*
                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>
*/}

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col>{t("I18N_Perm_code")}:</Col>
                <Col>{t("I18N_Description")}:</Col>
                <Col></Col>
                <Col></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col>{permissionAttrs.nameCode}</Col>
                <Col>
                  <textarea readOnly className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={permissionAttrs.description} />
                </Col>
                <Col></Col>
                <Col></Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{permissionAttrs.creatorUsername}</Col>
                <Col>{formatDate(permissionAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{permissionAttrs.updaterUsername}</Col>
                <Col>{formatDate(permissionAttrs.timeUpdated)}</Col>
              </Row>
            </Container>
          }
        </div>


        <hr className="solid" style={{ marginTop: '20px' }}></hr>

        <div className={classes.admin_pages__page_subtitle}>
          <Form.Group as={Row} className="mb-0 mt-1">
            <Col sm="2">
              <Button size="sm" variant="outline-secondary" className="mb-1"
                style={{ fontSize:'12px', fontWeight:'300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </Col>
{/*
            <Col sm="10">
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updatePermissionErrMsg}
              </span>
            </Col>
*/}
          </Form.Group>
        </div>

      </Card>
    </>
  );
}
 
export default PermissionAdminDetailsView;
